function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState, useCallback, useMemo, useContext } from 'react';
import { injectIntl } from 'react-intl';
import styles from './UserSelectWidget.module.scss';
import I18n from '../../../I18n/I18n/I18n';
import compose from '../../../utils/compose';
import en from './locales/UserSelectWidget.en.json';
import normalizeLocaleData from '../../../utils/i18n/normalizeLocaleData';
import uuid from '../../../utils/uuid';
import wrapSchemaWidget from '../wrapSchemaWidget';
import { withAdditionalIntl } from '../../../I18n/AdditionalIntl/AdditionalIntl';
import { WmButton, WmModal, WmModalFooter, WmModalHeader, WmTagInput, WmTagOption } from '@watermarkinsights/ripple-react';
import InlineError from '../../../Inputs/InlineError/InlineError';
import ThemeContext from '../../../ThemeContext';
var messages = normalizeLocaleData(en, '@dm/components.user-select-widget');
function getUsername(label) {
  try {
    return label.substring(label.indexOf('(') + 1, label.indexOf(')'));
  } catch (_unused) {
    return label;
  }
}
function UserSelectWidget(_ref) {
  var containerId = _ref.containerId,
    errorMsg = _ref.errorMsg,
    id = _ref.id,
    intl = _ref.intl,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    options = _ref.options,
    triggerData = _ref.triggerData,
    value = _ref.value;
  var enumOptions = options.enumOptions;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    modal = _useState2[0],
    setModal = _useState2[1];
  var _useState3 = useState(value),
    _useState4 = _slicedToArray(_useState3, 2),
    selection = _useState4[0],
    setSelection = _useState4[1];
  var uniqueId = useMemo(function () {
    return uuid();
  }, []);
  var theme = useContext(ThemeContext);
  var handleShowModal = useCallback(function (e) {
    setSelection(value);
    setModal(true);
    e.preventDefault();
  }, [value]);
  var handleHideModal = useCallback(function () {
    setModal(false);
  }, []);
  var handleApply = useCallback(function () {
    onChange(selection);
    onBlur();
    setModal(false);
  }, [selection]);
  var handleRemove = useCallback(function (e) {
    e.preventDefault();
    onChange(undefined);
    onBlur();
  }, [onChange]);
  var handleSelection = useCallback(function (e) {
    setSelection(e.target.id.split('-')[1]);
  }, []);
  var handleDeselection = useCallback(function (e) {
    setSelection(null);
  }, []);
  var display = useMemo(function () {
    if (!value) {
      return null;
    }
    var option = enumOptions.find(function (option) {
      return option.value === value;
    });
    if (!option) {
      return null;
    }
    return option.label;
  }, [value, enumOptions]);
  var colHeaders = useMemo(function () {
    return [intl.formatMessage({
      id: "@dm/components.user-select-widget.labels.uname"
    })].concat(_toConsumableArray(triggerData[0].targets.map(function (target) {
      return intl.formatMessage({
        id: "@dm/components.user-select-widget.labels.".concat(target)
      });
    }))).join(',');
  }, [triggerData]);
  var tagOptions = useMemo(function () {
    return enumOptions.map(function (option) {
      var data = triggerData[0].data;
      var result = {
        id: "id-".concat(option.value),
        key: "key-".concat(option.value),
        value: option.value
      };
      data[option.value].map(function (item, index) {
        result["col".concat(index + 2)] = item ? item : ' ';
      });
      result["col1"] = getUsername(option.label);
      return result;
    });
  }, [enumOptions, triggerData]);
  useEffect(function () {
    if (!modal) {
      document.body.style.overflow = '';
    }
  }, [modal]);
  return /*#__PURE__*/React.createElement("div", {
    id: containerId,
    className: styles.container
  }, !!value && /*#__PURE__*/React.createElement("div", {
    className: styles.card
  }, /*#__PURE__*/React.createElement("span", {
    className: "mdi mdi-tag ".concat(styles.tag)
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.name
  }, display, " "), /*#__PURE__*/React.createElement(WmButton, {
    labelForIdenticalButtons: intl.formatMessage({
      id: '@dm/components.user-select-widget.remove-tag'
    }) + ' ' + display,
    buttonType: "icononly",
    icon: "f739",
    onClick: handleRemove,
    tooltip: intl.formatMessage({
      id: '@dm/components.user-select-widget.remove-tag'
    })
  })), !value && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "".concat(styles.label, " ").concat(!!errorMsg ? styles.error : '')
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.user-select-widget.someone-at-institution"
  })), ' ', /*#__PURE__*/React.createElement("a", {
    className: styles.link,
    href: "#",
    id: id,
    onBlur: onBlur,
    onClick: handleShowModal
  }, /*#__PURE__*/React.createElement(I18n, {
    i18n: "@dm/components.user-select-widget.tag-them"
  })), !!errorMsg && /*#__PURE__*/React.createElement(InlineError, {
    i18n: errorMsg,
    id: "errors-".concat(id),
    metaType: "user-select",
    size: "large",
    theme: theme,
    type: "select"
  })), modal && /*#__PURE__*/React.createElement(WmModal, {
    open: modal,
    id: "modal-".concat(uniqueId),
    onWmModalCloseTriggered: handleHideModal,
    onWmModalPrimaryTriggered: handleApply,
    onWmModalSecondaryTriggered: handleHideModal,
    elementToFocus: "tag-input-".concat(uniqueId)
  }, /*#__PURE__*/React.createElement(WmModalHeader, {
    heading: intl.formatMessage({
      id: '@dm/components.user-select-widget.modal-heading'
    }),
    subheading: intl.formatMessage({
      id: '@dm/components.user-select-widget.modal-subheading'
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.body
  }, /*#__PURE__*/React.createElement(WmTagInput, {
    id: "tag-input-".concat(uniqueId),
    tagInputType: "table",
    label: intl.formatMessage({
      id: '@dm/components.user-select-widget.modal-subheading'
    }),
    labelPosition: "none",
    colHeaders: colHeaders,
    maxTags: 1,
    placeholder: selection ? '' : intl.formatMessage({
      id: '@dm/components.user-select-widget.search-placeholder'
    }),
    helpText: intl.formatMessage({
      id: '@dm/components.user-select-widget.selected'
    }, {
      count: selection ? 1 : 0
    }),
    onWmTagOptionSelected: handleSelection,
    onWmTagOptionDeselected: handleDeselection
  }, tagOptions.map(function (option) {
    return /*#__PURE__*/React.createElement(WmTagOption, Object.assign({}, option, {
      selected: option.value === selection
    }));
  }))), /*#__PURE__*/React.createElement(WmModalFooter, {
    primaryText: intl.formatMessage({
      id: '@dm/components.user-select-widget.apply'
    }),
    secondaryText: intl.formatMessage({
      id: '@dm/components.user-select-widget.cancel'
    })
  })));
}
export default compose(withAdditionalIntl(messages), injectIntl, wrapSchemaWidget)(UserSelectWidget);